import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const NotificationPreferencesModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "NotificationPreferencesModalContainer" */
      './NotificationPreferencesModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
